import React from 'react';
import {withCommas} from 'shared/utils';
import Stamp, {GREEN} from 'src/components/Stamp/Stamp';
import styles from './earning-stamp.module.scss';

interface Props {
  amount: number;
  divisor: number;
}

const EarningStamp = ({amount, divisor}: Props) => {
  const formattedAmount = `$${withCommas(Math.round(amount))}`;
  const formattedYearlyAmount = `$${withCommas(Math.round(amount / divisor))} / yr`;

  return (
    <div className={styles.earningStampContainer} data-testid="earning-stamp">
      <Stamp color={GREEN} className={styles.earningStampLeft}>
        {formattedAmount}
      </Stamp>
      <Stamp color={GREEN} className={styles.earningStampRight}>
        {formattedYearlyAmount}
      </Stamp>
    </div>
  );
};

export default EarningStamp;
